import {
  HestiaAppUse,
  HestiaAuthMethod,
  HestiaSupportedLanguage,
  IHestiaCoreConfig,
  IHestiaSentryConfig,
  OptionalExceptFor,
} from '@hestia/ngx-types';

import packageJson from '../../../../package.json';

export const DAWBA_SENTRY_DSN =
  'https://d1f71412e950447785890f87ba56bc26@sentry.zitelab.eu/36';

export interface IDawbaCoreConfig extends IHestiaCoreConfig {
  nemidUrl: string;
  testPatientUuid?: string;
  testPatientUserName?: string;
  testPatientPassword?: string;
  testParentUuid?: string;
  testParentUserName?: string;
  testParentPassword?: string;
  testTeacherUuid?: string;
  testTeacherUserName?: string;
  testTeacherPassword?: string;
  enableOnboarding?: boolean;
  syncStateToStorage: boolean;
  enableDevAdmin: boolean;
  backendAdminUser: string;
  backendAdminPassword: string;
  /** Prefetch all ValueSets as a part of the login process */
  prefetchValueSets: boolean;
  mitIdLoginUrl: string;
  mitIdLogoutUrl: string;
  mitIdCallbackRoute: string;
}

export class DawbaEnv implements IDawbaCoreConfig {
  production: boolean;
  debugMode: boolean;
  envName: string;
  apiUrl: string;
  availableLangs: HestiaSupportedLanguage[];
  defaultLang: HestiaSupportedLanguage;
  appBuiltFor: HestiaAppUse;
  defaultAuthMethod: HestiaAuthMethod;
  syncStateToStorage: boolean;
  syncStorageKey: string;
  syncHydratedKey: string;
  release: string;
  sentry: IHestiaSentryConfig;
  nemidUrl: string;
  testPatientUuid?: string;
  testPatientUserName?: string;
  testPatientPassword?: string;
  testParentUuid?: string;
  testParentUserName?: string;
  testParentPassword?: string;
  testTeacherUuid?: string;
  testTeacherUserName?: string;
  testTeacherPassword?: string;
  enableOnboarding?: boolean;
  enableDevAdmin: boolean;
  backendAdminUser: string;
  backendAdminPassword: string;
  prefetchValueSets: boolean;
  mitIdLoginUrl: string;
  mitIdLogoutUrl: string;
  mitIdCallbackRoute: string;
  constructor(
    config: OptionalExceptFor<
      IDawbaCoreConfig,
      | 'production'
      | 'debugMode'
      | 'envName'
      | 'sentry'
      | 'appBuiltFor'
      | 'nemidUrl'
      | 'enableOnboarding'
      | 'syncStateToStorage'
    >
  ) {
    this.production = config.production;
    this.debugMode = config.debugMode;
    this.envName = config.envName;
    this.apiUrl = config.apiUrl;
    this.availableLangs = config.availableLangs ?? ['da-DK', 'en-GB'];
    this.defaultLang = config.defaultLang ?? 'da-DK';
    this.appBuiltFor = config.appBuiltFor;
    this.defaultAuthMethod = config.defaultAuthMethod ?? 'NEMID';
    this.syncStorageKey =
      config.syncStorageKey ?? 'zitelab.eu.dawba.questionnaire.app';
    this.syncHydratedKey = config.syncHydratedKey ?? 'hydrated';
    this.release = config.release ?? packageJson.version;
    this.sentry = config.sentry;
    this.nemidUrl = config.nemidUrl;
    this.testPatientUuid = config?.testPatientUuid;
    this.testPatientUserName = config?.testPatientUserName;
    this.testPatientPassword = config?.testPatientPassword;
    this.testParentUuid = config?.testParentUuid;
    this.testParentUserName = config?.testParentUserName;
    this.testParentPassword = config?.testParentPassword;
    this.testTeacherUuid = config?.testTeacherUuid;
    this.testTeacherUserName = config?.testTeacherUserName;
    this.testTeacherPassword = config?.testTeacherPassword;
    this.enableOnboarding = config?.enableOnboarding ?? true;
    this.syncStateToStorage = config?.syncStateToStorage ?? true;
    this.enableDevAdmin = config?.enableDevAdmin ?? false;
    this.backendAdminUser = config?.backendAdminUser;
    this.backendAdminPassword = config?.backendAdminPassword;
    this.prefetchValueSets = config?.prefetchValueSets ?? true;
    this.mitIdLoginUrl = config?.mitIdLoginUrl;
    this.mitIdLoginUrl = config?.mitIdLoginUrl;
    this.mitIdCallbackRoute = config?.mitIdCallbackRoute;
    if (this.backendAdminUser || this.backendAdminPassword) {
      console.warn(
        'BACKEND user and/or password was found in env, only use when developing'
      );
    }
  }
}
